import React from "react";
import SingleEventPage from "../../components/single-event-page/SingleEventPage";
import TechnicalQuizImg from "../../assets/event-images/technical-quiz.jpg";

const technicalQuiz = {
  image: TechnicalQuizImg,
  description:
    "Are you ready to put your IT knowledge to the test? Join us for an electrifying evening of brain-teasing questions and tech-savvy challenges  This event is designed to bring together tech enthusiasts, students, and professionals to showcase their expertise in the vast world of Information Technology.",
  type: "Technical Event",
  eventName: "Technical Quiz",
  dateTime: "February 28, 12:00PM - 1:30PM",
  venue: "IT-442",
  rules: [
    "Team Participation: Each team must consist of 2-3 members.",
"Event Structure: The quiz will test participants on aptitude, code output prediction, and programming-related problem-solving. The event consists of two rounds.",
"Round 1: The Screening Quiz (Elimination Round) - This round will be conducted on platforms like Quizziz or Kahoot. The quiz will have a mix of easy, medium, and hard questions. Topics include logical reasoning, debugging, algorithmic thinking, and fundamental programming concepts. Top-performing teams will move to the next round.",
"Round 2: The Ultimate Code Battle (Offline Round) - This will be an offline, high-intensity round. The questions will be a mix of aptitude, code-tracing, and programming problem-solving. Teams will be challenged with real-time coding scenarios. The difficulty will be progressive, featuring easy, medium, and hard questions.",
"Rules: Judges' decisions are final.",
"The team with the highest score at the end of both rounds wins."
],

  firstprize: 1000,
  secondprize: 500,
  thirdprize: 0,
  contact: [
    {
      name: "Nilesh",
      phoneNo: "9994390896",
    },
    {
      name: "Ranjit",
      phoneNo: "9843826655",
    },
  ],
};

const TechnicalQuiz = () => {
  return <SingleEventPage eventDetails={technicalQuiz} />;
};

export default TechnicalQuiz;
